<template>
	<div id="onboardingNew" class="onboarding">
		<div class="steps-wrapper">
			<div v-if="onboarding">
				<router-link class="btn onboarding-back-btn" :to="'/onboarding'">
					<font-awesome-icon :icon="['fas', 'arrow-circle-left']" class="me-1" />
					Back
				</router-link>
				<div class="form-check form-switch align-items-center d-flex mb-1">
					<input class="form-check-input me-2" v-model="wide" type="checkbox" role="switch" />
					<label class="form-check-label">Wide</label>
				</div>
				<button
					v-for="step in onboardingSteps"
					:key="step.id + 'btn'"
					class="btn btn-secondary w-100 mb-3 onboarding-step-btn"
					:class="step.id == activeStep ? 'active' : ''"
					@click="selectStep(step)"
				>
					{{ step.name }}
				</button>
			</div>
		</div>
		<div class="fields-wrapper" :class="[{ 'wide-fields': wide }]" v-if="onboarding">
			<div class="onboarding-heading">
				<h3>{{ onboarding.name }}</h3>
				<p v-if="onboarding.type" class="onboarding-type">{{ onboarding.type.name }}</p>
				<p v-else class="onboarding-type text-danger">The onboarding type of this onboarding no longer exists.</p>
				<div v-if="loading" class="spinner-border spinner-border-sm" role="status">
					<span class="sr-only">load</span>
				</div>
			</div>
			<div class="onboarding-steps-wrapper mt-3">
				<div v-for="step in onboardingSteps" :key="step.id" class="onboarding-step mb-3">
					<div class="" v-if="activeStep == step.id">
						<h3 class="step-name">{{ step.name }}</h3>

						<div class="step-fields-wrapper">
							<div class="step-field" v-for="field in step.fields" :key="field.id">
								<template v-if="field.condition == '' || field.condition == null">
									<FieldInput :field="field" />
								</template>
								<template v-if="handleDisplayCondition(field.condition, step)">
									<FieldInput :field="field" />
								</template>
							</div>
							<div class="mt-4">
								<button class="btn w-100 onboarding-update-btn" :disabled="updatingStep" @click="updateStepFields(step)">
									<span v-if="updatingStep" class="spinner-border spinner-border-sm me-2" role="status"></span>
									{{ updatingStep ? 'Saving…' : 'Update' }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="slides-wrapper">
			<div></div>

			<div v-for="(aSlide, j) in activeSlides" :key="'slide-' + j" class="position-relative">
				<div class="test"></div>
				<div class="iframe-footer"></div>
				<iframe
					v-show="activeSlidesActive == aSlide.number"
					:src="iframeUrl + '?slide=' + aSlide.number + '&start=false&loop=false'"
					frameborder="0"
					class="iframe-content"
					allowfullscreen="true"
					mozallowfullscreen="true"
					webkitallowfullscreen="true"
				></iframe>
			</div>
			<!-- Always rendered (fixed height) so the pagination below never shifts -->
			<div v-if="activeSlides.length > 0" class="slide-image-action">
				<button v-if="activeSlide && activeSlide.image" class="slide-image-btn" @click="slideImageOpen = true">
					<font-awesome-icon :icon="['fas', 'image']" class="me-1" />
					{{ activeSlide.button_name || 'View image' }}
				</button>
			</div>
			<div v-if="activeSlides.length > 0" class="iframe-navigation">
				<button class="slide-nav-btn" :disabled="activeSlideIndex <= 0" @click="prevSlide">
					<font-awesome-icon :icon="['fas', 'chevron-left']" /> Prev
				</button>
				<button
					class="slide-num-btn"
					v-for="(slideItem, i) in activeSlides"
					:key="slideItem.number + '-num'"
					:class="{ active: activeSlidesActive == slideItem.number }"
					@click="activeSlidesActive = slideItem.number"
				>
					{{ i + 1 }}
				</button>
				<button class="slide-nav-btn" :disabled="activeSlideIndex >= activeSlides.length - 1" @click="nextSlide">
					Next <font-awesome-icon :icon="['fas', 'chevron-right']" />
				</button>
			</div>
		</div>

		<div
			v-if="slideImageOpen && activeSlide && activeSlide.image"
			class="slide-image-modal"
			role="dialog"
			aria-modal="true"
			:aria-label="activeSlide.button_name || 'Slide image'"
			@click.self="slideImageOpen = false"
		>
			<button type="button" class="btn-close slide-image-close" aria-label="Close" @click="slideImageOpen = false"></button>
			<img :src="activeSlide.image" :alt="activeSlide.button_name || ''" class="slide-image-img" />
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FieldInput from '../../components/onboarding/FieldInput.vue'
import restApi from '../../api/index'

export default {
	name: 'OnboardingNew',
	data() {
		return {
			loading: false,
			updatingStep: false,
			onboarding: null,
			activeStep: '',
			wide: false,
			activeSlides: [],
			activeSlidesActive: 1,
			slideImageOpen: false,
			//iframeUrl: 'https://docs.google.com/presentation/d/e/2PACX-1vTLroITdRbmc4cprhzXe7UH5QzlG117tYPql03cHD9_0Y4EBBiP2bXDudml-thmvIr-pgvLQXA2qYSh/embed',
			iframeUrl: 'https://docs.google.com/presentation/d/e/2PACX-1vT-GKZCWFLw8YhuiorB13-2Ra3rULqojJcnUqJ3zQE5DZ76QenounCz524MSVQBfpr3OYjISFH1IvAR/embed',
		}
	},
	components: { FieldInput },
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
		// The referenced type may have been deleted — render gracefully
		onboardingSteps() {
			return this.onboarding && this.onboarding.type ? this.onboarding.type.steps : []
		},
		activeSlideIndex() {
			return this.activeSlides.findIndex(slide => slide.number == this.activeSlidesActive)
		},
		activeSlide() {
			return this.activeSlides[this.activeSlideIndex] || null
		},
	},

	created() {
		this.getOnboarding()
	},
	mounted() {
		document.addEventListener('keydown', this.onKeydown)
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.onKeydown)
	},
	methods: {
		getOnboarding() {
			this.loading = true
			restApi
				.get('/onboarding/' + this.$route.params.id)
				.then(({ data }) => {
					this.onboarding = data
					this.loading = false
					//this.activeStep = this.onboarding.type.steps[0].id

					this.onboarding.type.steps.forEach(step => {
						if (step.slides && step.slides != null && step.slides != '') {
							step.slides = JSON.parse(step.slides)
						} else {
							step.slides = []
						}
					})
					this.selectStep(this.onboarding.type.steps[0])
					this.getClient()
				})
				.catch(error => {
					console.log(error)
					this.loading = false
				})
		},

		updateStepFields(step) {
			this.updatingStep = true
			restApi
				.post('/onboarding/' + this.$route.params.id + '/update', step)
				.then(() => {
					this.updatingStep = false
					this.$swal.fire({
						toast: true,
						position: 'top-end',
						icon: 'success',
						title: 'Saved!',
						timer: 2000,
						showConfirmButton: false,
					})
				})
				.catch(error => {
					console.log(error)
					this.updatingStep = false
					this.$swal.fire({ icon: 'error', title: 'Saving failed', text: String(error) })
				})
		},

		getFieldValue(field) {
			let data = {
				onboarding_step_id: field.onboarding_step_id,
				field_id: field.id,
			}
			restApi
				.post('/onboarding/' + this.$route.params.id + '/field-value', data)
				.then(({ data }) => {
					field.value = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		handleDisplayCondition(condition, step) {
			if (condition !== null) {
				const searchTerm = 'field_'
				const wordsContainingText = this.findWordsContainingText(condition, searchTerm)
				let fieldId = null
				if (wordsContainingText.length > 0) {
					fieldId = wordsContainingText[0].replace('field_', '')
				}
				if (fieldId) {
					let fieldValue = this.findValueForFieldId(step.fields, fieldId)
					condition = condition.replace(wordsContainingText[0], '"' + fieldValue + '"')
					return eval(condition)
				}
			}

			return false
		},

		findWordsContainingText(text, searchTerm) {
			const words = text.split(' ')
			const filteredWords = words.filter(word => word.includes(searchTerm))
			return filteredWords
		},

		findValueForFieldId(arr, id) {
			const foundObject = arr.find(obj => obj.id == id)
			if (foundObject.value === true) {
				foundObject.value = 1
			}
			if (foundObject.value === true) {
				foundObject.value = 0
			}
			return foundObject ? foundObject.value : ''
		},

		getClient() {
			let clientId = this.onboarding.client_id
			if (clientId) {
				restApi
					.get('/clients/' + clientId)
					.then(({ data }) => {
						console.log(data)
						//let client = data
						this.onboarding.type.steps.forEach(step => {
							step.fields.forEach(field => {
								if (field.code && field.code !== '') {
									field.value = data[field.code] ? data[field.code] : field.value
								}
							})
						})
					})
					.catch(error => {
						console.log(error)
					})
			}
		},

		selectStep(step) {
			this.activeStep = step.id
			this.activeSlides = step.slides
			if (this.activeSlides.length > 0) {
				this.activeSlidesActive = this.activeSlides[0].number
			}
		},
		onKeydown(e) {
			if (e.key === 'Escape') this.slideImageOpen = false
		},
		prevSlide() {
			if (this.activeSlideIndex > 0) {
				this.activeSlidesActive = this.activeSlides[this.activeSlideIndex - 1].number
			}
		},
		nextSlide() {
			if (this.activeSlideIndex < this.activeSlides.length - 1) {
				this.activeSlidesActive = this.activeSlides[this.activeSlideIndex + 1].number
			}
		},
	},

	watch: {
		activeSlidesActive() {
			this.slideImageOpen = false
		},
	},
}
</script>

<style scoped>
.punch-viewer-navbar-fixed {
	display: none;
}

.iframe-navigation {
	padding-left: 30px;
}

.test {
	width: 100%;
	background-color: transparent;
	z-index: 999;
	height: calc(100% - 71px);
	position: absolute;
}

.iframe-footer {
	background-color: #ffffff;
	width: 100%;
	z-index: 999;
	height: 71px;
	position: absolute;
	bottom: 0;
}

.iframe-content {
	width: 100%;
	height: 90vh;
	padding: 30px;
	border-radius: 30px;
}

/* Slide navigation — active slide highlighted + Prev/Next */
.iframe-navigation {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	padding-bottom: 20px;
}

.slide-num-btn {
	min-width: 22px;
	height: 22px;
	padding: 0 5px;
	border: 1px solid #e6e8ec;
	border-radius: 6px;
	background: #fff;
	color: #64748b;
	font-size: 11px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.slide-num-btn:hover {
	background: #f3f5f9;
	color: #2b303b;
}

.slide-num-btn.active {
	background: #657b98;
	border-color: #657b98;
	color: #ffffff;
}

.slide-nav-btn {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	height: 26px;
	padding: 0 11px;
	border: 1px solid #e6e8ec;
	border-radius: 999px;
	background: #fff;
	color: #2b303b;
	font-size: 11px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.12s ease;
}

.slide-nav-btn:hover:not(:disabled) {
	background: #f3f5f9;
}

.slide-nav-btn:disabled {
	opacity: 0.45;
	cursor: not-allowed;
}

.slide-nav-btn svg {
	font-size: 10px;
}

/* Slide image — button above pagination, opens the image in a modal */
.slide-image-action {
	height: 44px;
	padding: 0 0 10px 30px;
}

.slide-image-btn {
	display: inline-flex;
	align-items: center;
	padding: 6px 12px;
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	background: #fff;
	color: #334155;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
}

.slide-image-btn:hover {
	border-color: #cbd5e1;
	background: #f8fafc;
}

.slide-image-modal {
	position: fixed;
	inset: 0;
	z-index: 1060;
	overflow-y: auto;
	padding: 5vh 0;
	background: rgba(15, 23, 42, 0.75);
}

/* Image only: 90% of the screen width, centered; long images scroll inside the overlay */
.slide-image-img {
	display: block;
	width: 90vw;
	height: auto;
	margin: 0 auto;
	border-radius: 6px;
	box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);
}

.slide-image-close {
	position: fixed;
	top: 16px;
	right: 16px;
	z-index: 1;
	padding: 10px;
	border-radius: 50%;
	background-color: #fff;
	box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
	opacity: 1;
}
</style>
